import { render } from "./ImgContainer.vue?vue&type=template&id=b6962190&scoped=true"
import script from "./ImgContainer.vue?vue&type=script&lang=js"
export * from "./ImgContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b6962190"

export default script